import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/ibex_logo_new.png'


const _withScopeId = n => (_pushScopeId("data-v-bd325a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "app-header",
  class: "flex align-center"
}
const _hoisted_2 = { class: "flex justify-space-between flex-grow" }
const _hoisted_3 = { class: "header-left flex align-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header-link flex align-center logo",
  src: _imports_0,
  alt: "IBEX"
}, null, -1))
const _hoisted_5 = {
  id: "breadcrumbs",
  class: "flex align-center"
}
const _hoisted_6 = {
  key: 0,
  class: "header-link flex align-center cases_view"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "breadcrumbs-item flex align-center"
}
const _hoisted_9 = {
  key: 0,
  class: "k-icon k-i-arrow-chevron-right"
}
const _hoisted_10 = { class: "header-link flex align-center case_view" }
const _hoisted_11 = {
  key: 2,
  class: "breadcrumbs-item flex align-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-arrow-chevron-right" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "alerts_btn",
  class: "hide_on_click"
}, null, -1))
const _hoisted_14 = { class: "header-right flex align-center justify-end" }
const _hoisted_15 = {
  key: 0,
  id: "research-use-only-label"
}
const _hoisted_16 = {
  id: "user-controls",
  class: "flex align-center"
}
const _hoisted_17 = { class: "settings flex" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ib-h--v-divider" }, null, -1))
const _hoisted_19 = { class: "user flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IButton = _resolveComponent("IButton")!
  const _component_Insights = _resolveComponent("Insights")!
  const _component_IbIcons = _resolveComponent("IbIcons")!
  const _component_PreferencesPanel = _resolveComponent("PreferencesPanel")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (!_ctx.isDirectLink)
            ? (_openBlock(), _createElementBlock("a", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(_ctx.t("cases")), 1),
                (_ctx.incompleteCasesCount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.t("app_header.incomplete_cases", { count: _ctx.incompleteCasesCount })), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.activeCase)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (!_ctx.isDirectLink)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.activeCase.caseId), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.currentSlide?.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", null, _toDisplayString(_ctx.state.currentSlide.name), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_ctx.state.researchUse?.is_research_version)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.t("app_header.research_use_only", { msg: _ctx.t(`config.researchUse.label`) })), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.isFirstRead && _ctx.hasActiveCase)
            ? (_openBlock(), _createBlock(_component_IButton, {
                key: 0,
                text: _ctx.t('app_header.case_report'),
                icon: "file-txt",
                onClick: _ctx.toggleCaseReportModal,
                class: "case-report-button"
              }, null, 8, ["text", "onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isFirstRead)
            ? (_openBlock(), _createBlock(_component_Insights, { key: 1 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_IbIcons, {
              icon: "settings_menu",
              color: "white",
              onClick: _ctx.togglePreferences,
              pointer: ""
            }, null, 8, ["onClick"]),
            _withDirectives(_createVNode(_component_PreferencesPanel, null, null, 512), [
              [_vShow, _ctx.showPreferences]
            ])
          ]),
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_IbIcons, {
              icon: "user",
              color: "white"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.loggedInUserName), 1)
          ])
        ])
      ])
    ])
  ]))
}